export default __webpack_public_path__ + "static/setting-280f4ae738092e5f710400e7dcfbfaf8.png";